"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const React = require("react");
const EcsContext_1 = require("src/ts/contexts/EcsContext");
const HuddleApiClient_1 = require("src/ts/rest/HuddleApiClient");
const MeetingsApiClient_1 = require("src/ts/rest/MeetingsApiClient");
const ErrorHelper_1 = require("../../..//helpers/ErrorHelper");
const ErrorContext_1 = require("../../../contexts/ErrorContext");
const MeetingContext_1 = require("../../../contexts/meetings/MeetingContext");
const StackNavigationContext_1 = require("../../../contexts/StackNavigationContext");
const LoggerHelper_1 = require("../../../helpers/LoggerHelper");
const Captcha_1 = require("../../common/Captcha");
const GuestRedirect_1 = require("./GuestRedirect");
const maxGuestNameLength = 50;
class GuestLogin extends React.PureComponent {
    constructor(props) {
        super(props);
        this._onCaptchaLoad = () => {
            this.setState({ captcha: { ready: true, show: true }, joinButtonEnabled: true });
        };
        this._updateGuestName = (event) => {
            if (event.target.value && event.target.value.length > maxGuestNameLength) {
                return;
            }
            this.setState({
                guestName: event.target.value,
                joinButtonEnabled: !!event.target.value && event.target.value.length > 0,
            });
        };
        this._createGuest = (stackNavigationContext, meetingContext, errorContext, ecsContext) => {
            return (e) => {
                LoggerHelper_1.logger.action({ name: 'create-guest' });
                this.setState({ joinButtonEnabled: false, joinButtonSpinEnabled: true });
                if (this.state.captcha.show && this._captcha) {
                    this._captcha.verify((solution, error) => {
                        if (error) {
                            this.setState((oldState) => ({ joinButtonEnabled: true, joinButtonSpinEnabled: false, captcha: { ...oldState.captcha, error } }));
                            return;
                        }
                        this._joinAsGuest(meetingContext, stackNavigationContext, errorContext, ecsContext, solution);
                    });
                }
                else {
                    this._joinAsGuest(meetingContext, stackNavigationContext, errorContext, ecsContext);
                }
                e.preventDefault();
                e.stopPropagation();
            };
        };
        this._setCaptcha = (element) => {
            if (element) {
                this._captcha = element;
            }
        };
        this._joinAsGuest = (meetingContext, stackNavigationContext, errorContext, ecsContext, captchaSolution) => {
            LoggerHelper_1.logger.sessionFinished({ completionType: 'JoinOnWebAsGuest' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
            return ecsContext.settings.useMeetingsApi ?
                this.joinAsGuestMeetingsApi(meetingContext, stackNavigationContext, errorContext, captchaSolution) :
                this.joinAsGuestHuddleApi(meetingContext, stackNavigationContext, errorContext, captchaSolution);
        };
        this.joinAsGuestHuddleApi = (meetingContext, stackNavigationContext, errorContext, captchaSolution) => {
            return HuddleApiClient_1.default.joinAsGuest({
                flowId: LoggerHelper_1.logger.getSessionId(),
                name: this.state.guestName,
                threadId: meetingContext.conversation.resource,
                captcha: captchaSolution ? captchaSolution : undefined,
            }).then((guestUser) => {
                stackNavigationContext.push(React.createElement(GuestRedirect_1.GuestRedirect, { skypetoken: guestUser.skypetoken, username: this.state.guestName }), { eventViewName: 'guest-redirect', eventPriority: webjs_sdk_1.AWTEventPriority.Immediate_sync });
            }).catch((response) => {
                this.setState((oldState) => {
                    const newState = { ...oldState, joinButtonSpinEnabled: false, joinButtonEnabled: true };
                    const createGuestRequest = 'Create guest user';
                    let error;
                    switch (response.statusCode) {
                        case 405:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.JoinDisabled, response, createGuestRequest);
                            break;
                        case 403:
                            newState.joinButtonEnabled = false;
                            newState.captcha = {
                                ready: false,
                                show: true,
                            };
                            break;
                        case 412:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.TooManyUsers, response, createGuestRequest);
                            break;
                        case 500:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.Generic, response, createGuestRequest);
                            break;
                        default:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.Busy, response, createGuestRequest);
                            break;
                    }
                    if (error) {
                        errorContext.setError(error);
                        LoggerHelper_1.logger.error(error);
                    }
                    if (oldState.captcha.show && this._captcha) {
                        this._captcha.reloadHip();
                        newState.joinButtonEnabled = true;
                        newState.captcha = {
                            ready: true,
                            show: true,
                        };
                    }
                    return newState;
                });
            });
        };
        this.joinAsGuestMeetingsApi = (meetingContext, stackNavigationContext, errorContext, captchaSolution) => {
            return MeetingsApiClient_1.default.joinAsGuest({
                flowId: LoggerHelper_1.logger.getSessionId(),
                name: this.state.guestName,
                threadId: meetingContext.conversation.resource,
                shortId: meetingContext.shortId,
                captcha: captchaSolution ? captchaSolution : undefined,
            }).then((guestUser) => {
                stackNavigationContext.push(React.createElement(GuestRedirect_1.GuestRedirect, { skypetoken: guestUser.skypetoken, username: guestUser.skypeId }), { eventViewName: 'guest-redirect', eventPriority: webjs_sdk_1.AWTEventPriority.Immediate_sync });
            }).catch((response) => {
                this.setState((oldState) => {
                    const newState = { ...oldState, joinButtonSpinEnabled: false, joinButtonEnabled: true };
                    const createGuestRequest = 'Create guest user';
                    let error;
                    switch (response.statusCode) {
                        case 405:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.JoinDisabled, response, createGuestRequest);
                            break;
                        case 412: // @todo review all response codes
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.TooManyUsers, response, createGuestRequest);
                            break;
                        case 429:
                            newState.joinButtonEnabled = false;
                            newState.captcha = {
                                ready: false,
                                show: true,
                            };
                            break;
                        case 500:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.Generic, response, createGuestRequest);
                            break;
                        default:
                            error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.Busy, response, createGuestRequest);
                            break;
                    }
                    if (error) {
                        errorContext.setError(error);
                        LoggerHelper_1.logger.error(error);
                    }
                    if (oldState.captcha.show && this._captcha) {
                        this._captcha.reloadHip();
                        newState.joinButtonEnabled = true;
                        newState.captcha = {
                            ready: true,
                            show: true,
                        };
                    }
                    return newState;
                });
            });
        };
        this.state = {
            guestName: '',
            joinButtonEnabled: false,
            joinButtonSpinEnabled: false,
            captcha: {
                show: false,
                ready: false,
            },
            ecsContext: {
                settings: {
                    useMeetingsApi: false,
                    useUnifiedView: false,
                },
            },
        };
    }
    componentWillUnmount() {
        delete this._captcha;
    }
    componentWillUpdate(_nextProps, nextState) {
        if (!nextState.captcha.show && this.state.captcha.show) {
            delete this._captcha;
        }
    }
    render() {
        return React.createElement("form", { className: 'body guestLogin' },
            this._renderTitle(),
            this._renderExpirationWarning(),
            this._renderInput(),
            this.state.captcha.show && React.createElement(Captcha_1.Captcha, { ref: this._setCaptcha, onLoad: this._onCaptchaLoad }),
            this.state.captcha.show && !this.state.captcha.ready && React.createElement("div", null,
                React.createElement("div", { className: 'shimmer-container column' },
                    React.createElement("div", { className: 'shimmer captcha', style: { width: 216, height: 96 } }))),
            this.state.captcha.error && React.createElement(react_1.Text, { size: 'medium', styles: { color: 'darkred', marginTop: '0.5rem' }, weight: 'bold' },
                "* ",
                this.state.captcha.error),
            React.createElement("div", { className: 'actions' },
                React.createElement(StackNavigationContext_1.StackNavigationContextConsumer, null, (stackNavigationContext) => React.createElement(React.Fragment, null,
                    React.createElement(EcsContext_1.EcsContextConsumer, null, (ecsContext) => React.createElement(ErrorContext_1.ErrorContextConsumer, null, (errorContext) => React.createElement(MeetingContext_1.MeetingContextConsumer, null, (meetingContext) => meetingContext && meetingContext.conversation &&
                        React.createElement(React.Fragment, null,
                            this._renderTosAndPrivacy(),
                            React.createElement(react_1.Button, { id: 'btnCreateGuest', onClick: this._createGuest(stackNavigationContext, meetingContext, errorContext, ecsContext), disabled: !this.state.joinButtonEnabled },
                                React.createElement(react_1.Text, { weight: 'semibold' }, bew_localization_1.localizer.getString('Common.btn_join'))))))),
                    React.createElement(react_1.Button, { id: 'btnBack', onClick: stackNavigationContext.pop, text: true },
                        React.createElement(react_1.Text, { styles: { color: 'white' }, weight: 'semibold' }, bew_localization_1.localizer.getString('Common.btn_back')))))));
    }
    _renderTitle() {
        return React.createElement(react_1.Text, { size: 'larger', styles: { marginTop: '2rem' } }, bew_localization_1.localizer.getString('Login.btn_join_as_guest'));
    }
    _renderExpirationWarning() {
        return (React.createElement("div", null,
            React.createElement(EcsContext_1.EcsContextConsumer, null, (ecsContext) => ecsContext.settings.useUnifiedView ? React.createElement(react_1.Text, { size: 'small', styles: { marginTop: '0.2rem', color: '#a8abad' } }, bew_localization_1.localizer.getString('Login.txt_guest_account_expiration')) : React.createElement(React.Fragment, null))));
    }
    _renderInput() {
        const styles = {
            fontSize: '1rem',
            marginTop: '2rem',
            marginBottom: '1rem',
        };
        return React.createElement(react_1.Input, { id: 'inputGuestName', value: this.state.guestName, onChange: this._updateGuestName, autoFocus: true, styles: styles, placeholder: bew_localization_1.localizer.getString('Login.txt_placeholder_enter_name') });
    }
    _renderTosAndPrivacy() {
        const styles = {
            fontSize: '0.75rem',
            marginBottom: '1rem',
            textAlign: 'center',
        };
        return React.createElement(react_1.Text, { styles: styles }, bew_localization_1.localizer.get('txt_launch_guest_accept_tos', {
            linkPrivacy: { type: 'a', href: 'https://go.microsoft.com/fwlink/?LinkId=521839' },
            linkTerms: { type: 'a', href: 'https://go.microsoft.com/fwlink/?LinkID=246338' },
        }));
    }
}
exports.GuestLogin = GuestLogin;
